import { render, staticRenderFns } from "./AsfActionButton.vue?vue&type=template&id=35fa24f0"
import script from "./AsfActionButton.vue?vue&type=script&lang=js"
export * from "./AsfActionButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports